import type { ReactNode } from 'react'
import { createContext } from 'react'
import type { TableEditorState } from './useTableEditor'
import { useTableEditor } from './useTableEditor'

const TableEditorContext = createContext<TableEditorState | null>(null)

interface TableEditorProviderProps {
  fileId?: string
  sectionId?: string
  children: ReactNode
}

const TableEditorProvider = ({ fileId, sectionId, children }: TableEditorProviderProps) => {
  const state = useTableEditor(fileId, sectionId)
  return <TableEditorContext value={state}>{children}</TableEditorContext>
}

export { TableEditorContext, TableEditorProvider }
